// Import site styling
import './../scss/app.scss';

// Import and assign the Alpine function to the global window object
import Alpine from 'alpinejs';
window.Alpine = Alpine;

// Import and assign the initializeSearch function to the global window object
import prepareAlgoliaSearch from './Algolia/algoliaSearch';
prepareAlgoliaSearch();

import prepareSliderEnhancement from './Components/slider.js';
prepareSliderEnhancement();

import prapareNumbedList from './Components/numbedList.js';
prapareNumbedList();

import pgoInit from './Pgo/app-pgo.js'
pgoInit();

Alpine.start();

import prepareTextareaMaxLengthList from './Components/formTextareaLength.js';
prepareTextareaMaxLengthList();

import prepareSearchHighlight from './Components/searchHighlight.js';
prepareSearchHighlight();

import prepareNewsletterForm from './Components/newsletterForm.js';
prepareNewsletterForm();

// @see https://nystudio107.com/docs/vite/#entry-script-hmr
if (import.meta.hot) {
  import.meta.hot.accept(() => {
  });
}
